   // check4dnr/src/components/NavBar.js
   import React, { useContext } from 'react';
   import { AppBar, Toolbar, Typography, Button } from '@mui/material';
   import { Link } from 'react-router-dom';
   import { UserContext } from '../context/UserContext';

   function NavBar() {
     const { userGuid, clearUser } = useContext(UserContext);

     const handleLogout = () => {
       clearUser();
     };

     return (
       <AppBar position="static">
         <Toolbar>
           <Typography variant="h6" sx={{ flexGrow: 1 }}>
             Check4DNR
           </Typography>
           <Button color="inherit" component={Link} to="/">
             Home
           </Button>
           {!userGuid ? (
             <>
               <Button color="inherit" component={Link} to="/signup">
                 Sign Up
               </Button>
               <Button color="inherit" component={Link} to="/login">
                 Log In
               </Button>
             </>
           ) : (
             <>
               <Button color="inherit" component={Link} to="/profile">
                 Profile
               </Button>
               <Button color="inherit" onClick={handleLogout}>
                 Log Out
               </Button>
             </>
           )}
         </Toolbar>
       </AppBar>
     );
   }

   export default NavBar;